import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'
import { ButtonSizeType, ButtonType } from './index'

export const Loader = styled.div<{ size?: ButtonSizeType }>`
  ${({ theme, size }) => css`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    ${size === 'sm'
      ? css`
          width: 18px;
          height: 18px;
        `
      : css`
          width: 18px;
          height: 18px;

          ${theme.breakpoints.up(1024)} {
            width: 28px;
            height: 28px;
          }
        `}
    svg {
      width: 100%;
      height: 100%;
      fill: ${theme.colors.black};
    }
  `}
`

const yellowBtn = () => css`
  ${({ theme }) => css`
    color: ${theme.colors.black};
    fill: ${theme.colors.black};
    background: ${theme.colors.yellow};
    border-color: ${theme.colors.yellow};

    &:hover {
      background: #f5ff74;
      border-color: #f5ff74;
    }

    &:active {
      background: #edff00;
      border-color: #edff00;
    }

    &:disabled {
      color: ${theme.colors.grey};
      fill: ${theme.colors.grey};
      background: ${theme.colors.greyDark};
      border-color: ${theme.colors.greyDark};
    }
  `}
`

const whiteBtn = (border?: boolean) => css`
  ${({ theme }) => css`
    color: ${theme.colors.black};
    fill: ${theme.colors.black};
    background: ${theme.colors.white};
    border-color: ${theme.colors.white};

    &:hover {
      color: ${theme.colors.greyExtraDark};
      fill: ${theme.colors.greyExtraDark};
      background: ${theme.colors.greyLight};
      border-color: ${theme.colors.greyLight};
    }

    &:active {
      color: ${theme.colors.dark};
      fill: ${theme.colors.dark};
      background: ${theme.colors.white};
      border-color: ${theme.colors.white};
    }

    &:disabled {
      color: ${theme.colors.grey};
      fill: ${theme.colors.grey};
      background: ${theme.colors.greySemiDark};
      border-color: ${theme.colors.greySemiDark};
    }

    ${border &&
    css`
      background: transparent;
      border-color: ${theme.colors.black};

      &:hover {
        color: ${theme.colors.white};
        fill: ${theme.colors.white};
        background: ${theme.colors.black};
        border-color: ${theme.colors.black};
      }

      &:active {
        color: ${theme.colors.white};
        fill: ${theme.colors.white};
        background: ${theme.colors.dark};
        border-color: ${theme.colors.dark};
      }

      &:disabled {
        color: ${theme.colors.greySemiDark};
        fill: ${theme.colors.greySemiDark};
        border-color: ${theme.colors.greySemiDark};
        background: transparent;
      }
    `}
  `}
`

const blackBtn = (border?: boolean) => css`
  ${({ theme }) => css`
    color: ${theme.colors.white};
    fill: ${theme.colors.white};
    background: ${theme.colors.black};
    border-color: ${theme.colors.black};

    &:hover {
      background: ${theme.colors.greyExtraDark};
      border-color: ${theme.colors.greyExtraDark};
    }

    &:active {
      background: ${theme.colors.dark};
      border-color: ${theme.colors.dark};
    }

    &:disabled {
      color: ${theme.colors.white};
      fill: ${theme.colors.white};
      background: ${theme.colors.grey};
      border-color: ${theme.colors.grey};
    }

    ${border &&
    css`
      color: ${theme.colors.white};
      fill: ${theme.colors.white};
      border-color: ${theme.colors.greyDark};

      &:hover {
        color: ${theme.colors.black};
        fill: ${theme.colors.black};
        background: ${theme.colors.white};
        border-color: ${theme.colors.white};
      }

      &:active {
        color: ${theme.colors.black};
        fill: ${theme.colors.black};
        background: ${theme.colors.greyLight};
        border-color: ${theme.colors.greyLight};
      }

      &:disabled {
        color: ${theme.colors.greySemiDark};
        fill: ${theme.colors.greySemiDark};
        border-color: ${theme.colors.greyDark};
      }
    `}
    ${Loader} {
      svg {
        fill: ${theme.colors.white};
      }
    }
  `}
`

const violetBtn = () => css`
  ${({ theme }) => css`
    color: ${theme.colors.violet};
    fill: ${theme.colors.violet};
    background: ${theme.colors.white};
    border-color: ${theme.colors.white};

    &:active {
      background: ${theme.colors.dark};
      border-color: ${theme.colors.dark};
    }

    &:disabled {
      color: ${theme.colors.white};
      fill: ${theme.colors.white};
      background: ${theme.colors.grey};
      border-color: ${theme.colors.grey};
    }
    ${Loader} {
      svg {
        fill: ${theme.colors.violet};
      }
    }
  `}
`

const transparentBtn = () => css`
  ${({ theme }) => css`
    fill: ${theme.colors.black};
    background: transparent;
    border-color: transparent;

    &:hover {
      background: ${theme.colors.black};
      border-color: ${theme.colors.black};
      fill: ${theme.colors.white};
    }

    &:active {
      background: ${theme.colors.grey};
      border-color: ${theme.colors.grey};
      fill: ${theme.colors.black};
    }

    &:disabled {
      fill: ${theme.colors.grey};
      background: ${theme.colors.greySemiLight};
      border-color: ${theme.colors.greySemiLight};
    }
  `}
`

const greyBtn = () => css`
  ${({ theme }) => css`
    color: ${theme.colors.black};
    fill: ${theme.colors.black};
    background: ${theme.colors.greySemiLight};
    border-color: ${theme.colors.greySemiLight};

    &:hover {
      background: ${theme.colors.grey};
      border-color: ${theme.colors.grey};
    }

    &:active {
      background: ${theme.colors.grey};
      border-color: ${theme.colors.grey};
    }

    &:disabled {
      color: ${theme.colors.grey};
      fill: ${theme.colors.grey};
      background: ${theme.colors.greySemiLight};
      border-color: ${theme.colors.greySemiLight};
    }
  `}
`

const greyDarkBtn = () => css`
  ${({ theme }) => css`
    color: ${theme.colors.grey};
    fill: ${theme.colors.black};
    background: ${theme.colors.greyDark};
    border-color: ${theme.colors.greyDark};

    &:hover {
      background: ${theme.colors.greyDark};
      border-color: ${theme.colors.greyDark};
    }

    &:active {
      background: ${theme.colors.greyDark};
      border-color: ${theme.colors.greyDark};
    }

    &:disabled {
      color: ${theme.colors.greyDark};
      fill: ${theme.colors.greyDark};
      background: ${theme.colors.greyDark};
      border-color: ${theme.colors.greyDark};
    }
  `}
`

const circle = (size?: ButtonSizeType) => css`
  ${({ theme }) => css`
    border-radius: 50%;
    display: flex;
    align-items: center;
    text-align: center;

    ${size === 'xs' &&
    css`
      height: 24px;
      width: 24px;
      min-width: 24px;
    `}

    ${size === 'sm' &&
    css`
      height: 32px;
      width: 32px;
      min-width: 32px;
    `}

    ${typeof size === 'number' &&
    css`
      height: ${size}px;
      width: ${size}px;
      min-width: ${size}px;
    `}

    ${!size &&
    css`
      height: 40px;
      width: 40px;
      min-width: 40px;

      ${theme.breakpoints.up(1024)} {
        height: 52px;
        width: 52px;
        min-width: 52px;
      }
    `}
  `}
`

const defaultButtonStyle = (size?: ButtonSizeType) => css`
  ${({ theme }) => css`
    ${size === 'sm'
      ? css`
          font-size: 12px;
          line-height: 1.5;
          padding: 6px 16px;
          border-radius: 21px;
          height: 32px;
        `
      : css`
          font-size: 16px;
          line-height: 1.5;
          padding: 6px 16px;
          border-radius: 21px;
          height: 40px;

          ${theme.breakpoints.up(1024)} {
            font-size: 20px;
            line-height: 1.4;
            padding: 11px 30px;
            border-radius: 45px;
            height: 52px;
          }
        `}
  `}
`

const globalCss = css<ButtonType>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  white-space: nowrap;
  outline: none;
  transition: 0.3s;
  font-weight: bold;
  border: 1px solid transparent;
  position: relative;

  ${({ size, $shape, themetype = 'black', $border, $loading }) => css`
    ${themetype === 'yellow' && yellowBtn()}
    ${themetype === 'violet' && violetBtn()}
    ${themetype === 'white' && whiteBtn($border)}
    ${themetype === 'grey' && greyBtn()}
    ${themetype === 'greyDark' && greyDarkBtn()}
    ${themetype === 'transparent' && transparentBtn()}
    ${themetype === 'black' && blackBtn($border)}

    ${$shape === 'circle' && circle(size)}
    ${!$shape && defaultButtonStyle(size)}

    ${$loading &&
    css`
      pointer-events: none;
      cursor: not-allowed;
      color: transparent !important;
      fill: transparent !important;
    `}
  `}
  & > svg {
    & + span {
      margin-left: 4px;
    }
  }

  & > span {
    & + svg {
      margin-right: 4px;
    }
  }

  &:disabled {
    cursor: not-allowed;
  }
`

export const StyledButton = styled.button<ButtonType>`
  ${globalCss}
`

export const StyledButtonLink = styled(Link)<ButtonType>`
  ${globalCss}
`
